import Notify from 'quasar/src/plugins/Notify.js';;

export function handleFileRejected(rejectedEntries, t) {
  const firstRejected = rejectedEntries?.[0];
  if (!firstRejected) return;

  let message = "";

  switch (firstRejected.failedPropValidation) {
    case "accept":
      message = t("events.form.fileFormat")+'dasd';
      break;
    case "max-file-size":
      message = t("events.form.fileSize");
      break;
    default:
      message = t("events.form.upload");
      break;
  }

  Notify.create({
    icon: "warning",
    color: "negative",
    message,
    timeout: 3000,
  });
}
